import queryString from 'query-string';

import { filterNulls, objectEmpty } from '#/utils/functional/object';

function trimTrailingSlash(s: string) {
  return s.replace(/\/$/, '');
}

export function pathWithParams(
  path: string | null | undefined,
  params: Readonly<Record<string, string | null | undefined>>,
) {
  if (!path) return '';
  if (objectEmpty(params)) return path;
  const [pathWithoutHash, hashPart] = path.split('#');
  const [pathWithoutQuery, search] = pathWithoutHash.split('?');
  const trimmedPath = trimTrailingSlash(pathWithoutQuery);
  return `${trimmedPath}?${queryString.stringify({
    ...filterNulls(params),
    ...queryString.parse(search),
  })}${hashPart ? `#${hashPart}` : ''}`;
}
